import { useTranslation } from 'react-i18next';
import { supabase } from '../supabaseClient';

const AMBER = '#F5A623';
const WHITE = '#FFFFFF';
const FONT_BODY = "'DM Sans', sans-serif";

// Compact EN/ES pill toggle for nav bars. Pass `userId` on any logged-in dashboard so the
// choice persists to user_preferences (upsert on user_id); omit it on logged-out/pre-auth
// pages, where i18n's own localStorage-backed state (src/i18n/index.js) is enough.
// large: phone-size tap targets (44px tall) -- opt-in, so every existing caller is unchanged.
// fullWidth: fill the container as two equal halves, each label centered (the phone nav menu).
export default function LanguageToggle({ userId, dark = false, large = false, fullWidth = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('es') ? 'es' : 'en';

  const setLang = async (lang) => {
    if (lang === current) return;
    i18n.changeLanguage(lang);
    if (userId) {
      const { error } = await supabase
        .from('user_preferences')
        .upsert({ user_id: userId, language: lang, updated_at: new Date().toISOString() }, { onConflict: 'user_id' });
      if (error) console.error('[i18n] failed to save language preference:', error);
    }
  };

  const base = {
    border: 'none', cursor: 'pointer', fontFamily: FONT_BODY,
    fontSize: '0.7rem', fontWeight: 700, padding: '4px 9px', letterSpacing: '0.02em',
    ...(large ? { fontSize: '0.875rem', minWidth: '44px', minHeight: '44px', padding: '0 12px' } : {}),
    ...(fullWidth ? { flex: '1 1 50%', minWidth: 0, textAlign: 'center' } : {}),
  };
  const inactiveColor = dark ? 'rgba(13,27,42,0.45)' : fullWidth ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.45)';
  const trackBg = dark ? 'rgba(13,27,42,0.06)' : 'rgba(255,255,255,0.08)';

  return (
    <div
      role="group"
      aria-label="Language"
      style={{
        display: 'flex', backgroundColor: trackBg, borderRadius: '999px', padding: '2px', flexShrink: 0,
        ...(fullWidth ? { width: '100%' } : {}),
      }}
    >
      <button
        type="button"
        onClick={() => setLang('en')}
        aria-pressed={current === 'en'}
        style={{
          ...base, borderRadius: '999px',
          backgroundColor: current === 'en' ? AMBER : 'transparent',
          color: current === 'en' ? '#0D1B2A' : inactiveColor,
        }}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang('es')}
        aria-pressed={current === 'es'}
        style={{
          ...base, borderRadius: '999px',
          backgroundColor: current === 'es' ? AMBER : 'transparent',
          color: current === 'es' ? '#0D1B2A' : inactiveColor,
        }}
      >
        ES
      </button>
    </div>
  );
}
